/* main.js - 你的原版逻辑 + Vue3 最小顺序改造 */
import * as Vue from 'vue'
import App from './App'
//路由
import router from './router'
import store from './store'
//element库
import '@fortawesome/fontawesome-free/css/all.min.css'
import vue3SeamlessScroll from 'vue3-seamless-scroll'
//element-plus库
import ElementPlus from 'element-plus'
import * as Icons from '@element-plus/icons-vue'
import 'element-plus/theme-chalk/index.css'
import 'element-plus/theme-chalk/display.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'   // 中文包
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
//全局图标
import "vue3-social-share/lib/index.css"; // 必须引入样式
import SocialShare from "vue3-social-share";
// main.js
import useClipboard from 'vue-clipboard3'   // 注意这里是函数
const { toClipboard } = useClipboard()     // 取出复制函数


import '@/assets/css/home.css'
import '@/assets/css/pages.css'
import '@/assets/font/iconfont.css'
import 'ie-placeholder'

//公共api地址
window.$vueApp = {} // 先占坑

const app = Vue.createApp(App) // 创建实例

Object.keys(Icons).forEach(key => {
  app.component(key, Icons[key])
})
app.use(ElementPlus, { locale: zhCn })
app.use(vue3SeamlessScroll)
app.component('vue-qr', vueQr)

//下载
import $Download from '@/assets/js/xiazai.js'
//页面默认的title
app.config.globalProperties.WindTitle = '三才师范站点'
//qq登录组件控制
app.config.globalProperties.IsQQLogin = false
app.config.globalProperties.$Download = $Download
app.config.globalProperties.$copyText = toClipboard   // 手动挂全局
//公共组件
import DocumentsNewsBlockControl from '@/components/DocumentsNewsBlockControl/DocumentsNewsBlockControl'
import Mlogin from '@/components/MLoginControl'
import CommonPage from '@/components/CommonPage'
import ArticleList from '@/components/IssueArticleListControl/ArticleList.vue'
app.component('DocumentsNewsBlockControl', DocumentsNewsBlockControl)
app.component('Mlogin', Mlogin)
app.component('CommonPage', CommonPage) //分页器
app.component('ArticleList', ArticleList) //列表

//公共api地址
app.config.globalProperties.Url = window.apiHosts + '/'
app.config.globalProperties.ImgUrl = window.apiHosts + '/image/'

//打开新页面
app.config.globalProperties.$newOpen = function () {
  let path = arguments[0]
  if (process.env.NODE_ENV == 'production' && path.startsWith('/#')) {
    let tmp = location.pathname
    if (tmp.endsWith('/')) {
      tmp = tmp.substring(0, tmp.length - 1)
    }
    arguments[0] = tmp + path
  }
  window.open.apply(window, arguments)
}
//关闭/回退  可以回退就回退 没有路由就关闭页面
app.config.globalProperties.$closeOrBack = function () {
  if (window.history.length <= 1) {
    window.close()
  } else {
    router.go(-1)
  }
}
//回到首页
app.config.globalProperties.$goHome = function () {
  let path = '/#/'
  if (process.env.NODE_ENV == 'production' && path.startsWith('/#')) {
    let tmp = location.pathname
    if (tmp.endsWith('/')) {
      tmp = tmp.substring(0, tmp.length - 1)
    }
    path = tmp + path
  }
  location.href = path
}
app.config.globalProperties.$base = function (text, type) {
  let reg = ''
  switch (type) {
    case 'phone': //手机号码
      reg = /^1[345789]\d{9}$/
      break
    case 'pass': //密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位
      reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[.!@#_])[\da-zA-Z.!@#_]{8,16}$/
      break
    case 'email': //邮箱
      reg =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/
      break
    case 'users': //密码
      reg =
        /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/])[\da-zA-Z~!@#$%^&*()_+`\-={}:";'<>?,.\/]{6,16}$/
      break
    case 'name': //用户名
      reg = /[a-zA-Z0-9_]{4,16}$/
      break
    case 'aff': //非法判断
      reg =
        /select|update|delete|truncate|join|union|exec|install|insert|drop|count|'|"|;|>|</i
      break
    default:
      console.log('未知正则名称:', type)
      break
  }
  if (reg.test(text)) {
    return true
  } else {
    return false
  }
}

app.config.globalProperties.resetSetItem = function (key, newVal) {
  if (key === 'eqcode') {
    var newStorageEvent = document.createEvent('StorageEvent')
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val)
        newStorageEvent.initStorageEvent(
          'setItem',
          false,
          false,
          k,
          null,
          val,
          null,
          null
        )
        window.dispatchEvent(newStorageEvent)
      },
    }
    return storage.setItem(key, newVal)
  }
}

app.config.globalProperties.$DownloadBase64File = function (
  Guid,
  type
) {
  let url = ''
  let params = {}
  let openurl = ''
  if (type == 1) {
    url = '_OpenFilebyGuid'
    openurl = window.apiHost + '/api/Common/OpenFilebyGuid?FileGUID='
  } else if (type == 2) {
    url = '_OpenMessageFilebyGuid'
    openurl = window.apiHost + '/api/Common/OpenMessageFilebyGuid?FileGUID='
  }
  params = { FileGUID: Guid }
  this.$store
    .dispatch(url, params)
    .then((res) => {
      this.$store.state.progressNum = 1
      let Guids = encodeURIComponent(Guid)
      window.location = openurl + Guids
    })
    .catch((errs) => {
      console.log(errs)
    })
}

//关键字高亮显示
app.config.globalProperties.$brightkeyWords = function (
  val,
  keyWords
) {
  //val:返回的date数据，keywords:文本框输入的关键词
  var key1 = keyWords.replace(' ', '').replace('　', '')
  var key2 = keyWords.replace(' ', '').replace('　', '')
  if (key1.length == 2) {
    key1 = key1.slice(0, 1) + ' ' + key1.slice(1)
  }
  if (key2.length == 2) {
    key2 = key2.slice(0, 1) + '　' + key2.slice(1)
  }
  if (
    val.indexOf(keyWords) != -1 ||
    val.indexOf(key1) != -1 ||
    val.indexOf(key2) != -1
  ) {
    return val
      .replace(keyWords, `<span color='red'>${keyWords}</span>`)
      .replace(key1, `<span color='red'>${key1}</span>`)
      .replace(key2, `<span color='red'>${key2}</span>`)
  } else {
    return val
  }
}
//不为空判断
app.config.globalProperties.$Bai = function (str) {
  if (
    str == undefined ||
    str == '' ||
    str == null ||
    str == 'null' ||
    str == 'undefined'
  ) {
    return true
  }
  return false
}
  //是否有空格
  ; (app.config.globalProperties.$Space = (str) => {
    var reg = /\s/
    if (reg.test(str)) {
      return true
    }
    return false
  }),
    //是不是IE
    (app.config.globalProperties.$IEVersion = () => {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return true
      } else {
        return false
      }
    })
// //路由title
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let path = to.path
  //判断是哪个页面 控住头部，轮播图，底部，登录版块的显示、隐藏
  if (
    /(Login|login_qq|LookforPassword|Nopassword|regist|Rss|ForgetPassword)/g.test(
      path
    )
  ) {
    store.state.top = false
    store.state.user = false
    store.state.footer = false
    store.state.banner = false
    store.state.fileLoading = true
  } else {
    store.state.top = true
    store.state.user = true
    store.state.footer = true
    store.state.banner = true
    store.state.fileLoading = true
  }
  if (localStorage.getItem('userInfo')) {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    let ExpiresDate = JSON.parse(localStorage.getItem('userInfo')).ExpiresDate
    let data = new Date(ExpiresDate).getTime()
    let nowData = new Date().getTime()
    if (data - nowData <= 0) {
      localStorage.removeItem('userInfo')
    }
  }
  next()
})
/* eslint-disable no-new */

app.config.globalProperties.routerAppend = (path, pathToAppend) => {
  return path + (path.endsWith('/') ? '' : '/') + pathToAppend
}
//vuex 状态管理
app.use(store)
app.use(router)
app.use(SocialShare);
// 把真正的 app 实例挂到 window
window.$vueApp = app
app.mount('#app')
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})